var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.015625 15.1536H15.9844V16.9279H0.015625V15.1536ZM8.88715 9.98294L14.2731 4.59694L15.5278 5.85157L8 13.3793L0.47226 5.85157L1.72688 4.59694L7.11285 9.98294V0.0720215H8.88715V9.98294Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportArrow);
export default __webpack_public_path__ + "static/media/exportArrow.3bbf7f6258e6b391e9dedee50f5cf59c.svg";
export { ForwardRef as ReactComponent };